var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpeMinor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 52,
    height: 53,
    rx: 6.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 52,
    height: 53,
    rx: 6.5,
    stroke: "#0089EC",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6998 40.8946H16.2998C16.2998 40.8946 17.1998 34.4473 27.9998 34.4473C38.7998 34.4473 39.6998 40.8946 39.6998 40.8946Z",
    stroke: "#0089EC",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 34.4473V40.8946",
    stroke: "#0089EC",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6001 34.4473V40.8946",
    stroke: "#0089EC",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3002 25.2368H21.7002C21.7002 25.2368 23.5002 31.6842 28.0002 31.6842C32.5002 31.6842 34.3002 25.2368 34.3002 25.2368Z",
    stroke: "#0089EC",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6955 16.405C24.543 16.8081 23.3644 17.5603 22.6 18.7897C22.4428 19.0425 22.3491 19.3058 22.2997 19.5653C22.0995 20.6166 21.6975 21.8607 20.7046 22.1994L20.6152 22.2299C20.165 22.3835 19.8116 22.7451 19.6615 23.2059C19.3361 24.2052 20.0628 25.2371 21.0921 25.2371H34.9079C35.9371 25.2371 36.664 24.2052 36.3385 23.2059C36.1884 22.7451 35.8351 22.3835 35.3847 22.2299L34.8512 22.0479C34.0144 21.7625 33.5176 20.8883 33.4152 19.9918C33.3318 19.2633 33.0946 18.4342 32.5 17.8687C31.7431 17.1487 31.0631 16.6864 30.344 16.405",
    stroke: "#0089EC",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2002 21.5527V15.1054C26.2002 14.5967 26.6031 14.1843 27.1002 14.1843H28.9002C29.3972 14.1843 29.8002 14.5967 29.8002 15.1054V21.5527",
    stroke: "#0089EC",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpeMinor);
export default __webpack_public_path__ + "static/media/ppe-minor.da69b330e6691f2c72d0408703c17d64.svg";
export { ForwardRef as ReactComponent };